import { InvoiceActionResult } from './../models/invoice-action-result';
import { EmptyData } from '@admin/core/models/empty-data';
import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { Observable } from 'rxjs';
import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { InvoiceListItemModel } from '../models/invoice-list-item-model';
import { InvoiceListFilterModel } from '../models/invoice-list-filter-model';
import { InvoiceListTotalAmount } from '../models/invoice-list-total-amount';
import { SendInvoiceRequestModel } from '@admin/billing/shared/send-invoice-request-model';
import { SendInvoiceResultModel } from '@admin/billing/shared/send-invoice-result-model';
import { UrlConfigService } from '@hrra/core';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public listInvoices(
    filter: PagingFilter<InvoiceListFilterModel>
  ): Observable<PagingWrapper<InvoiceListItemModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.invoices.list,
      filter.toObject(),
      InvoiceListItemModel
    );
  }

  public getInvoicesTotalAmount(
    filter: PagingFilter<InvoiceListFilterModel>
  ): Observable<InvoiceListTotalAmount> {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.total,
      filter.toObject(),
      InvoiceListTotalAmount
    );
  }

  public mergeInvoice(
    invoices: InvoiceListItemModel[]
  ): Observable<InvoiceActionResult> {
    let data = {
      InvoiceIds: invoices.map((c) => c.invoiceId),
    };

    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.merge,
      data,
      InvoiceActionResult
    );
  }

  public unmergeInvoice(
    invoice: InvoiceListItemModel
  ): Observable<InvoiceActionResult> {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.unmerge,
      { InvoiceId: invoice.invoiceId },
      InvoiceActionResult
    );
  }

  public updateInvoiceActivationDate(invoiceId: number, date: Date) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.updateDate,
      { InvoiceId: invoiceId, date: date },
      EmptyData
    );
  }

  public updateInvoiceAccountingStatus(invoiceId: number, statusId: number) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.updateAccounting,
      { InvoiceId: invoiceId, status: statusId },
      EmptyData
    );
  }

  public approveInvoice(
    invoices: InvoiceListItemModel[]
  ): Observable<InvoiceActionResult> {
    let data = {
      InvoiceIds: invoices.map((c) => c.invoiceId),
    };

    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.approve,
      data,
      InvoiceActionResult
    );
  }

  public sendInvoice(data: SendInvoiceRequestModel) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.invoices.sendInvoice,
      data,
      SendInvoiceResultModel
    );
  }
}
